import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { GlobalServices } from '../global.services';
declare var window;

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent implements OnInit {
  urlParam: any;
  msg = '';
  userData: any;
  tranData: any;
  userId: any;
  dataLayer: Array<any> = [];
  public showHollyMessage:boolean = false;
  public showManageHealthConfirmation: boolean = false;
  constructor(public route: ActivatedRoute, public appService: ApiService, public globalService: GlobalServices) { }

  ngOnInit() {
    if (this.globalService?.isBrowser) {
      this.route.params.subscribe(param => {
        this.urlParam = param;
      });
      this.route.queryParams.subscribe(res => {
        if (res) {
          this.userId = res;
        }
      })

      this.route.queryParams.subscribe(params => {
        let holly = params['holly'];
        let manageHealth = params['managehealth'];
        if(holly){
          this.showHollyMessage = true
        }
        this.showManageHealthConfirmation = manageHealth === true || manageHealth === 'true';
        this.globalService?.hideHeader.next(this.showManageHealthConfirmation);
        this.globalService?.hideFooter.next(this.showManageHealthConfirmation);
      });
    }
    this.setPaymentComplete()
    let ssoOption = localStorage.getItem("sso")
    if (ssoOption) {
      window.location.href = ssoOption
    }

  }

  redirectToHollywood() {
    window.location.href = 'https://hollywoodfl.virtuagym.com/';
  }







  payInfo() {
    let Url = 'billingservice/usersubscription/user/' + (this.userId.userId ? this.userId.userId : '');
    this.appService.getDatabill(Url).subscribe(response => {
      if (response && response['data']) {
        this.tranData = [{
          orderId: response['data']['orderId'],
          price: response['data']['price'],
          transactionId: response['data']['transactionId'],
          isPaymentMade: response['data']['isPaymentMade']
        }];
      }
      if (this.globalService?.isBrowser && this.tranData['orderId']) {
        setTimeout(() => {
          this.demo();
        }, 100);
      }
    });
  }

  // vendorPaymentInfo(){

  // }

  setPaymentComplete() {
    this.globalService?.postUserActivityLog({
      paymentCompleted: true,
    });
    let localStorageObj = JSON.parse(
      localStorage.getItem('userActivityLog')
    );
    localStorage.setItem(
      'userActivityLog',
      JSON.stringify({
        ...localStorageObj,
        ...{ paymentCompleted: true },
      })
    );
    localStorage.removeItem('planpayment');
    localStorage.removeItem('dataArray');
    this.globalService.isActivePlan = 1; // for user buy the plan so remove flag from Header component using global service !!
    localStorage?.setItem('isActivePlan', '1');
  }

  /*   paymentConfirm() {
      this.payData = response;
      this.globalServices?.postUserActivityLog({
        paymentCompleted: true,
      });
      let localStorageObj = JSON.parse(
        localStorage.getItem('userActivityLog')
      );
      localStorage.setItem(
        'userActivityLog',
        JSON.stringify({
          ...localStorageObj,
          ...{ paymentCompleted: true },
        })
      );
      if (response && response.paymentDeducted) {
        this.showAlert = true;
        this.responseMessage = 'Payment Successfull!';
      }
      localStorage.removeItem('planpayment');
      localStorage.removeItem('dataArray');
      setTimeout(() => {
        localStorage.removeItem('bookingpage');
        localStorage.setItem(
          'planUserId',
          JSON.stringify({
            userId: this.payData['userId'],
          })
        );
        this.mode = 'determinate';
        this.changeDetectorRef.detectChanges();
        this.router.navigate(['/confirmation']);
      }, 1000);
      this.globalServices.isActivePlan = 1; // for user buy the plan so remove flag from Header component using global service !!
      localStorage?.setItem('isActivePlan', '1');

      this.changeDetectorRef.detectChanges();
    }
 */
  // demo(){      
  //   window.dataLayer = window.dataLayer || [];  
  //    window['dataLayer'].push({
  //  'event':'orderCompleteNow',
  //  'transactionId': this.tranData && this.tranData.orderId ? this.tranData.orderId:'', 
  //  'transactionTotal': this.tranData && this.tranData.price ? this.tranData.price:'', 
  //  'transactionProducts': [{
  //    'sku': this.tranData && this.tranData.itinerary && this.tranData.itinerary.programSlug  ? this.tranData.itinerary.programSlug : '',
  //    'name': this.tranData && this.tranData.itinerary && this.tranData.itinerary.programName  ? this.tranData.itinerary.programName : '',
  //    'category': this.tranData && this.tranData.itinerary && this.tranData.itinerary.categoryName  ? this.tranData.itinerary.categoryName : '',
  //    'price': this.tranData && this.tranData.price ? this.tranData.price:'',  
  //    'quantity': 1 
  //  }]
  // });
  // }

  demo() {
    window.dataLayer.push({
      'event': 'orderCompleteNow',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': this.tranData && this.tranData.orderId ? this.tranData.orderId : '',                         // Transaction ID. Required for purchases and refunds.
            'affiliation': '',
            'revenue': '',                     // Total transaction value (incl. tax and shipping)
            'tax': '',
            'shipping': '',
            'coupon': ''
          },
          'products': [{                            // List of productFieldObjects.
            'name': this.tranData && this.tranData.itinerary && this.tranData.itinerary.programName ? this.tranData.itinerary.programName : '',     // Name or ID is required.
            'id': this.tranData && this.tranData.orderId ? this.tranData.orderId : '',
            'price': this.tranData && this.tranData.price ? this.tranData.price : '',
            'brand': 'Mytripwell',
            'category': this.tranData && this.tranData.itinerary && this.tranData.itinerary.categoryName ? this.tranData.itinerary.categoryName : '',
            'variant': '',
            'quantity': 1,
            'coupon': ''                            // Optional fields may be omitted or set to empty string.
          }
          ]
        }
      }
    });
  }


}
